<style type="text/css">
  .customers-steps .ui-state-disabled {
    display: none;
    visibility: hidden;
  }
</style>
<div class="Customers customer-company ui-g">

  <div class="ui-g-12">
    <p-messages></p-messages>
  </div>

  <div class="ui-g ui-fluid" style="width: 100%">
    <div class="ui-g-12" [hidden]="isLoading">
      <div>
        <div class="ui-g ui-g-nopad form-group master-data">
          <div class="ui-g-12 ui-lg-8 ui-g-nopad">
            <h1 class="step-title" *ngIf="!mdmCustomerPermission">{{ this.titlePage | translate}} <span
                *ngIf="basicInfo">{{ basicInfo.name }} {{ basicInfo.surname }} - {{ basicInfo.customerCode }}</span>
            </h1>
            <h1 class="step-title" *ngIf="mdmCustomerPermission && mdmCustomerInfo">{{mdmCustomerInfo.name}}
              {{mdmCustomerInfo.surname}}</h1>
          </div>

          <div class="ui-g-12 ui-lg-4 text-right">
            <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left"
              label="{{ 'common.back' | translate }}" (click)="confirm()"></button>
            <button pButton *ngIf="!mdmCustomerPermission" type="button" class="k-generic-btn" icon="fa fa-floppy-o"
              iconPos="left" label="{{ 'common.save' | translate }}"
              (click)="customerMgPermission ? checkCustomerLogin() : save()"></button>
            <!--<button
            pButton
            *ngIf="!mdmCustomerPermission && customerMgPermission"
            type="button"
            class="k-generic-btn"
            icon="fa fa-floppy-o"
            iconPos="left"
            label="{{ 'common.save' | translate }}"
            (click)="saveMg()"></button>-->
          </div>

          <div class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps" [hidden]="isLoading">
            <p-steps [style]="{'width': '100%'}" [model]="items" [(activeIndex)]="activeTabIndex"
              (activeIndexChange)="onTabChange($event)" [readonly]="false"></p-steps>
          </div>
        </div>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.basicInfo">

        <app-customer-basic *ngIf="!mdmCustomerPermission && !customerMgPermission && show.basic"
          [hidden]="this.activeTabIndex !== activeTab.basicInfo" [customerId]="customerId"
          (basicInfoLoaded)="basicInfoLoaded($event)" (dirtyFormData)="checkFormData($event)"></app-customer-basic>

        <app-customer-basic-new *ngIf="!mdmCustomerPermission && customerMgPermission && show.basic"
          [hidden]="this.activeTabIndex !== activeTab.basicInfo" [customerId]="customerId" [cardInfo]="cards"
          (basicInfoLoaded)="basicInfoLoaded($event)" (cardsInfoLoaded)="cardsInfoLoaded($event)"
          (dirtyFormData)="checkFormData($event)"
          (allMandatoryFieldsOkLoaded)="allMandatoryFieldsOkLoaded($event)"></app-customer-basic-new>

        <div id="mdm-customer-info" *ngIf="mdmCustomerPermission && mdmCustomerInfo">
          <table>
            <tr *ngIf="mdmCustomerInfo.name">
              <th>{{'customerDetail.name' | translate}}</th>
              <td>{{mdmCustomerInfo.name}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.surname">
              <th>{{'customerDetail.surname' | translate}}</th>
              <td>{{mdmCustomerInfo.surname}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.birthDate">
              <th>{{'customerDetail.birthday' | translate}}</th>
              <td>{{mdmCustomerInfo.birthDate}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.address1">
              <th>{{'customerDetail.address' | translate}}</th>
              <td>{{mdmCustomerInfo.address1}} {{mdmCustomerInfo.addressNumber}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.zipCode">
              <th>{{'customerDetail.zip' | translate}}</th>
              <td>{{mdmCustomerInfo.zipCode}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.city">
              <th>{{'customerDetail.city' | translate}}</th>
              <td>{{mdmCustomerInfo.city}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.province">
              <th>{{'customerDetail.province' | translate}}</th>
              <td>{{mdmCustomerInfo.province}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.email">
              <th>Email</th>
              <td>{{mdmCustomerInfo.email}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.currentCluster">
              <th>{{'customerDetail.currentCluster' | translate}}</th>
              <td>{{mdmCustomerInfo.currentCluster}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.cardState">
              <th>{{'customerDetail.cardState' | translate}}</th>
              <td>{{mdmCustomerInfo.cardState}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.expirationDate">
              <th>{{'customerDetail.expirationDate' | translate}}</th>
              <td>{{mdmCustomerInfo.expirationDate}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.telephone">
              <th>{{'customerDetail.telephone' | translate}}</th>
              <td>{{mdmCustomerInfo.telephone}}</td>
            </tr>
            <tr *ngIf="mdmCustomerInfo.mobile">
              <th>{{'customerDetail.mobile' | translate}}</th>
              <td>{{mdmCustomerInfo.mobile}}</td>
            </tr>
          </table>
        </div>

      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.challengesInfo" *ngIf="challengePermission">
        <app-customer-challengeinfo [hidden]="this.activeTabIndex !== activeTab.challengesInfo"
          [customerId]="customer_id">
        </app-customer-challengeinfo>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.familyInfo" *ngIf="editMode && familyPermission">
        <app-customer-familyinfo [hidden]="this.activeTabIndex !== activeTab.familyInfo" [customerId]="customerId"
          (dirtyFormData)="checkFormData($event)"></app-customer-familyinfo>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.hobbyPetInfo"
        *ngIf="editMode && hobbyPetPermission">
        <app-customer-hobbypetinfo [hidden]="this.activeTabIndex !== activeTab.hobbyPetInfo" [customerId]="customerId"
          (dirtyFormData)="checkFormData($event)"></app-customer-hobbypetinfo>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.serviceInfo"
        *ngIf="editMode && servicePermission && customer_id">
        <app-customer-serviceinfo [hidden]="this.activeTabIndex !== activeTab.serviceInfo" [customerId]="customer_id"
          (dirtyFormData)="checkFormData($event)"></app-customer-serviceinfo>
      </div>


      <div class="card" [hidden]="this.activeTabIndex !== activeTab.clustersInfo" *ngIf="editMode && show.permissions">
        <app-customer-clusters [hidden]="this.activeTabIndex !== activeTab.clustersInfo" [customerId]="customerId"
          [basicInfo]="basicInfo" [cards]="cards" [mdmCustomerPermission]="mdmCustomerPermission"
          [mgCustomerPermission]="customerMgPermission" [kloyCustomerPermission]="customerKloyPermission"
          (clusterChanged)=clusterChangedHandler($event) (clusterListChanged)="clusterListChangedHandler($event)">
        </app-customer-clusters>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.shoppingInfo"
        *ngIf="editMode && shoppingPermission">
        <app-customer-shoppinginfo [hidden]="this.activeTabIndex !== activeTab.shoppingInfo"
          [customerId]="customerId"></app-customer-shoppinginfo>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.loyaltyInfo"
        *ngIf="editMode && show.loyaltyInfo && show.permissions">
        <kv-customer-loyaltyinfo [hidden]="this.activeTabIndex !== activeTab.loyaltyInfo" [cards]="cards"
          [customerId]="customerId" [basicInfo]="basicInfo" [activeTabIndex]="activeTabIndex"
          (cardOperationDone)="customerClustersComponent.saveCustomerCluster()" (addCardDone)="cardAddDone()"
          (domiciliationDone)="domiciliationDone()" (cardSubstitutionDone)="cardSubstitutionDone()"
          (cardBlacklistDone)="cardBlacklistDone()" (noCardLinked)="noCardLinked()"
          [customerPermissions]="customerPermissions"
          [loyaltyPermissions]="loyaltyPermissions"></kv-customer-loyaltyinfo>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.familyCard"
        *ngIf="editMode && familyCardPermission">
        <app-family-card [hidden]="this.activeTabIndex !== activeTab.familyCard" [customerHostId]="customerId">
        </app-family-card>
      </div>

      <!-- Tab Customer Ext Cluster Analytics -->
      <div [hidden]="this.activeTabIndex !== activeTab.extClusterAnalytics"
        *ngIf="customerExtClusterAnalytics && customerExt">
        <app-ext-cluster-analytics [customerHostId]="customerId"></app-ext-cluster-analytics>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== activeTab.customerModuleInfo"
        *ngIf="editMode && basicInfo && cardInfo && customerMgPermission && show.uploadModule">
        <app-upload-mg [customerHostId]="customerId" [basicInfo]="basicInfo"
          (customerHasFiles)="customerHasFiles = $event"></app-upload-mg>
      </div>

      <p-confirmDialog key="confirm"></p-confirmDialog>

    </div>

    <!-- Tab Coupon Manager -->
    <div [hidden]="this.activeTabIndex !== activeTab.couponManager" *ngIf="couponManagerPermission && customer_id">
      <app-coupon-manager [hidden]="this.activeTabIndex !== activeTab.couponManager" [customerId]="this.customer_id"
        [couponTab]="this.activeTabIndex"></app-coupon-manager>
    </div>

    <!-- Tab Premi -->
    <div class="card" [hidden]="this.activeTabIndex !== activeTab.catalogoPremi"
      *ngIf="catalogoPremiPermission && customer_id">
      <app-catalogo-premi [hidden]="this.activeTabIndex !== activeTab.catalogoPremi"
        [customerId]="this.customer_id"></app-catalogo-premi>
    </div>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/customer-detail.component.html